import { render } from "./AuthWrapper.vue?vue&type=template&id=2fbdc57c"
import script from "./AuthWrapper.vue?vue&type=script&lang=js"
export * from "./AuthWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__